import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Blog from "./Blog";
import Faq from "./Faq";
import axios from "axios";
import config from "../config";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderimage from "../image/placeholder.jpg";
import TrendingGym from "./TrendingGym";
import FeaturedGym from "./FeaturedGym";
import Loader from "./Loader";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchGymCategory } from "../redux/slice/GymCategory";
import member from "../image/membership.jpg";
import appstore from "../image/appstore.png";
import playstore from "../image/playstore.png";
import appScreenshot from "../image/ss1.png";

export default function Homepage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryData, isLoading, isError } = useSelector(
    (state) => state.GymCategory
  );
  useEffect(() => {
    dispatch(fetchGymCategory());
  }, [dispatch]);

  //Searching the gym and navigating to the list page
  const [search, setSearch] = useState("");

  //Fetching the availbale city
  const [city, setCity] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}/city-list`);
        setCity(response.data.city_list);
      } catch (error) {
        // silently fail — cities list stays empty
      }
    };
    fetchData();
  }, []);

  //Categroy responsive
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 8,
      slidesToSlide: 2,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 7,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 577 },
      items: 6,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 3.5,
      slidesToSlide: 1,
    },
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>MeraGym - Find Your Ideal Gym | Best Fitness Centers Near You</title>
          <meta
            name="keywords"
            content="gym near me, fitness center near me, best gym in India, yoga studio near me, CrossFit gym near me, zumba classes near me, gym membership, personal trainer near me, weight loss gym, bodybuilding gym, fitness club near me, health club near me, ladies gym near me, unisex gym near me, gym for beginners, gym with swimming pool, cardio gym, strength training gym, functional fitness center, MMA gym near me, boxing gym near me, pilates studio, aerobics classes, gym in Varanasi, gym in Delhi, gym in Mumbai, gym in Bangalore, gym in Hyderabad, gym in Chennai, gym in Pune, gym in Kolkata, gym in Jaipur, gym in Lucknow, cheap gym membership, affordable gym near me, premium gym near me, 24 hour gym, open gym, gym with sauna, gym with steam room, gym with personal training, online gym booking, find gym, compare gyms, gym reviews India, meragym, mera gym"
          />
          <meta
            name="description"
            content="Find the best gyms, yoga studios, CrossFit centers, and fitness clubs near you on MeraGym. Browse 5,000+ verified gyms across India, compare memberships, read real reviews, and book your free trial today!"
          />
          <link rel="canonical" href="https://meragym.com" />
          <meta property="og:title" content="MeraGym - Find the Best Gyms Near You" />
          <meta property="og:description" content="Discover top-rated gyms, yoga centers, and fitness studios in your city. Compare, review, and join the perfect gym." />
          <meta property="og:url" content="https://meragym.com" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://meragym.com/og-home.jpg" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="MeraGym - Find the Best Gyms Near You" />
          <meta name="twitter:description" content="Discover top-rated gyms, yoga centers, and fitness studios in your city." />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "name": "MeraGym",
                "url": "https://meragym.com",
                "description": "India's leading gym discovery platform — find gyms, yoga studios, and fitness centers near you.",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": { "@type": "EntryPoint", "urlTemplate": "https://meragym.com/search/{search_term_string}" },
                  "query-input": "required name=search_term_string"
                }
              },
              {
                "@type": "Organization",
                "name": "MeraGym",
                "url": "https://meragym.com",
                "logo": "https://meragym.com/logo.png",
                "sameAs": [
                  "https://www.facebook.com/meragym/",
                  "https://www.instagram.com/meragymofficial/",
                  "https://www.youtube.com/@meragym/"
                ]
              }
            ]
          })}</script>
        </Helmet>
      </HelmetProvider>
      <div className="imgSlider">
        <div className="container">
          <h1 className="BuyHeading">
            Find the Perfect Gym <span className="text-danger">Near You</span>
          </h1>
          <h2 className="BuySHead">Free · Fast · Trusted by 5,000+ Fitness Centers across India</h2>
          <div className="input-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              className="bi bi-search text-danger"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Enter your city or area..."
            />
            <Link
              type="button"
              to={search.trim() === "" ? "/varanasi/gym" : `/search/${search.trim()}`}
              className="button btn btn-danger"
            >
              Search
            </Link>
          </div>
        </div>
      </div>
      {/* B2B / app strip removed — was interrupting gym-finder flow */}
      <div className="container-fluid offBg">
        <div className="container head-row px-0">
          <h5 className="offHead">Categories</h5>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="off-sec">
                <Carousel
                  responsive={responsive}
                  swipeable={true}
                  draggable={true}
                  infinite={false}
                  showDots={false}
                  autoPlay={false}
                  autoPlaySpeed={3000}
                  removeArrowOnDeviceType={["mobile"]}
                >
                  {categoryData.map((cData) => {
                    return (
                      <Link
                        to={`/varanasi/${cData.slug}`}
                        className="cat-list"
                        key={cData.id}
                      >
                        <div className="d-flex flex-column text-center">
                          <div className="gym-category-circle">
                            <img
                              src={cData.image || placeholderimage}
                              onError={(e) => { e.target.src = placeholderimage; }}
                              loading="lazy"
                              className="gym-category-pic"
                              alt={cData.name}
                            />
                          </div>
                          <span className="category-name">{cData.name}</span>
                        </div>
                      </Link>
                    );
                  })}
                </Carousel>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="container-fluid">
        <div className="container px-0">
          <div className="row head-row">
            <div className="col-8">
              <h5 className="offHead text-start">Trending Fitness Centers</h5>
            </div>
            <div className="col-4">
              <Link to="/varanasi/gym" className="see-link">
                See All
                <i className="bi bi-arrow-right-circle-fill ms-1"></i>
              </Link>
            </div>
          </div>
          <TrendingGym />
        </div>

        <div className="container px-0">
          <div className="row head-row">
            <div className="col-8">
              <h5 className="offHead text-start">Featured Fitness Centers</h5>
            </div>
            <div className="col-4">
              <Link to="/varanasi/gym" className="see-link">
                See All
                <i className="bi bi-arrow-right-circle-fill ms-1"></i>
              </Link>
            </div>
          </div>
          <FeaturedGym />
        </div>

        <div className="container px-0">
          <div className="row head-row">
            <div className="col-8">
              <h5 className="offHead text-start">The Fitness Blog</h5>
            </div>
            <div className="col-4">
              <Link to="/blog" className="see-link">
                See All
                <i className="bi bi-arrow-right-circle-fill ms-1"></i>
              </Link>
            </div>
          </div>
          <Blog />
        </div>

        {/* Gym Software Banner */}
        <div className="gymsoft-banner-section">
          <div className="gymsoft-glow gymsoft-glow-1"></div>
          <div className="gymsoft-glow gymsoft-glow-2"></div>
          <div className="container">
            {/* Top label */}
            <div className="gymsoft-top-label">
              <span className="gymsoft-badge">
                <i className="bi bi-stars me-1"></i> All-in-One Gym Management SaaS
              </span>
            </div>

            <div className="gymsoft-banner-inner">
              {/* Left: content */}
              <div className="gymsoft-banner-left">
                <h2 className="gymsoft-heading">
                  Run Your Gym Like a<br />
                  <span className="gymsoft-highlight">Pro Business</span>
                </h2>
                <p className="gymsoft-subtext">
                  MeraGym Software gives gym owners a complete command center — automate billing, track attendance, manage trainers, and never miss a renewal. Trusted by <strong>5,000+ gyms</strong> across India.
                </p>

                <div className="gymsoft-feature-grid">
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-people-fill"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Member Management</div>
                      <div className="gymsoft-feature-desc">Profiles, history &amp; plans</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-credit-card-fill"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Auto Billing</div>
                      <div className="gymsoft-feature-desc">Collect payments on autopilot</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-bell-fill"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Renewal Reminders</div>
                      <div className="gymsoft-feature-desc">Auto SMS &amp; WhatsApp alerts</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-calendar-check-fill"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Attendance Tracking</div>
                      <div className="gymsoft-feature-desc">Biometric &amp; app check-ins</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-journal-text"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Day Book</div>
                      <div className="gymsoft-feature-desc">Daily income &amp; expense log</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-receipt"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Invoice Management</div>
                      <div className="gymsoft-feature-desc">Generate &amp; share instantly</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-person-badge-fill"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Trainer Management</div>
                      <div className="gymsoft-feature-desc">Schedule, pay &amp; review trainers</div>
                    </div>
                  </div>
                  <div className="gymsoft-feature-card">
                    <div className="gymsoft-feature-icon"><i className="bi bi-bar-chart-fill"></i></div>
                    <div>
                      <div className="gymsoft-feature-title">Reports &amp; Analytics</div>
                      <div className="gymsoft-feature-desc">Revenue, growth &amp; insights</div>
                    </div>
                  </div>
                </div>

                <div className="gymsoft-cta-row">
                  <a
                    href="https://app.meragym.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gymsoft-cta-btn"
                  >
                    Start Free Trial <i className="bi bi-arrow-right ms-2"></i>
                  </a>
                  <a
                    href="https://app.meragym.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gymsoft-cta-secondary"
                  >
                    <i className="bi bi-play-circle me-1"></i> Watch Demo
                  </a>
                </div>
                <p className="gymsoft-no-cc">No credit card required &nbsp;·&nbsp; Free setup &nbsp;·&nbsp; Cancel anytime</p>
              </div>

              {/* Right: stats + trust */}
              <div className="gymsoft-banner-right">
                <div className="gymsoft-stats">
                  <div className="gymsoft-stat-item">
                    <div className="gymsoft-stat-icon"><i className="bi bi-buildings-fill"></i></div>
                    <strong>5,000+</strong>
                    <span>Gyms Onboarded</span>
                  </div>
                  <div className="gymsoft-stat-item">
                    <div className="gymsoft-stat-icon"><i className="bi bi-emoji-smile-fill"></i></div>
                    <strong>98%</strong>
                    <span>Satisfaction Rate</span>
                  </div>
                  <div className="gymsoft-stat-item">
                    <div className="gymsoft-stat-icon"><i className="bi bi-lightning-charge-fill"></i></div>
                    <strong>₹0</strong>
                    <span>Setup Cost</span>
                  </div>
                  <div className="gymsoft-stat-item">
                    <div className="gymsoft-stat-icon"><i className="bi bi-headset"></i></div>
                    <strong>24/7</strong>
                    <span>Support</span>
                  </div>
                </div>
                <div className="gymsoft-trust-row">
                  <i className="bi bi-shield-fill-check"></i> Secure &amp; Reliable Platform
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why MeraGym Features Section */}
        <section className="mg-features-section">
          <div className="mg-features-bg-decor" aria-hidden="true">
            <span className="mg-features-decor-circle mg-features-decor-1"></span>
            <span className="mg-features-decor-circle mg-features-decor-2"></span>
          </div>
          <div className="container" style={{position:"relative"}}>
            <div className="mg-features-header">
              <span className="mg-features-pill"><i className="bi bi-stars me-1"></i>Why MeraGym?</span>
              <h2 className="mg-features-title">Everything You Need to Find the <span className="text-danger">Perfect Gym</span></h2>
              <p className="mg-features-subtitle">India's smartest gym discovery platform — built for real fitness seekers across 50+ cities.</p>
            </div>

            <div className="mg-features-grid">
              <div className="mg-feature-card">
                <div className="mg-feature-card-top">
                  <div className="mg-feature-icon-wrap">
                    <i className="bi bi-search-heart"></i>
                  </div>
                  <span className="mg-feature-stat">5,000+ Gyms</span>
                </div>
                <h3 className="mg-feature-card-title">Discover Nearby Gyms</h3>
                <p className="mg-feature-card-desc">Browse verified gyms, yoga studios, CrossFit boxes, and fitness centers across India — all in one place.</p>
                <div className="mg-feature-card-footer">
                  <i className="bi bi-arrow-right-circle-fill"></i> Search now
                </div>
              </div>

              <div className="mg-feature-card">
                <div className="mg-feature-card-top">
                  <div className="mg-feature-icon-wrap">
                    <i className="bi bi-star-fill"></i>
                  </div>
                  <span className="mg-feature-stat">Real Reviews</span>
                </div>
                <h3 className="mg-feature-card-title">Verified Reviews</h3>
                <p className="mg-feature-card-desc">Read honest member reviews before you join. No fake ratings — just real, moderated feedback from actual gym-goers.</p>
                <div className="mg-feature-card-footer">
                  <i className="bi bi-arrow-right-circle-fill"></i> Read reviews
                </div>
              </div>

              <div className="mg-feature-card">
                <div className="mg-feature-card-top">
                  <div className="mg-feature-icon-wrap">
                    <i className="bi bi-bar-chart-line-fill"></i>
                  </div>
                  <span className="mg-feature-stat">Best Deals</span>
                </div>
                <h3 className="mg-feature-card-title">Compare Plans & Prices</h3>
                <p className="mg-feature-card-desc">Compare membership plans, facilities, and pricing side-by-side so you always get the best value for your budget.</p>
                <div className="mg-feature-card-footer">
                  <i className="bi bi-arrow-right-circle-fill"></i> Compare gyms
                </div>
              </div>

              <div className="mg-feature-card">
                <div className="mg-feature-card-top">
                  <div className="mg-feature-icon-wrap">
                    <i className="bi bi-funnel-fill"></i>
                  </div>
                  <span className="mg-feature-stat">20+ Filters</span>
                </div>
                <h3 className="mg-feature-card-title">Smart Filters</h3>
                <p className="mg-feature-card-desc">Filter by type, city, amenities like pool or sauna, ladies-only, AC, 24-hour access, and budget range.</p>
                <div className="mg-feature-card-footer">
                  <i className="bi bi-arrow-right-circle-fill"></i> Use filters
                </div>
              </div>

              <div className="mg-feature-card">
                <div className="mg-feature-card-top">
                  <div className="mg-feature-icon-wrap">
                    <i className="bi bi-person-check-fill"></i>
                  </div>
                  <span className="mg-feature-stat">Certified Pros</span>
                </div>
                <h3 className="mg-feature-card-title">Find Certified Trainers</h3>
                <p className="mg-feature-card-desc">Connect with certified personal trainers in your city for customised workout plans, diet advice, and coaching.</p>
                <div className="mg-feature-card-footer">
                  <i className="bi bi-arrow-right-circle-fill"></i> Find trainers
                </div>
              </div>

              <div className="mg-feature-card mg-feature-card--free">
                <div className="mg-feature-card-top">
                  <div className="mg-feature-icon-wrap">
                    <i className="bi bi-shield-fill-check"></i>
                  </div>
                  <span className="mg-feature-stat">₹0 Cost</span>
                </div>
                <h3 className="mg-feature-card-title">100% Free to Use</h3>
                <p className="mg-feature-card-desc">No hidden charges, no sign-up fees. Discover, compare, and connect with gyms near you — completely free, forever.</p>
                <div className="mg-feature-card-footer">
                  <i className="bi bi-arrow-right-circle-fill"></i> Get started free
                </div>
              </div>
            </div>

            {/* Trust Stats Bar */}
            <div className="mg-features-stats-bar">
              <div className="mg-features-stat-item">
                <strong>5,000+</strong>
                <span>Gyms Listed</span>
              </div>
              <div className="mg-features-stat-divider"></div>
              <div className="mg-features-stat-item">
                <strong>50+</strong>
                <span>Cities Covered</span>
              </div>
              <div className="mg-features-stat-divider"></div>
              <div className="mg-features-stat-item">
                <strong>1 Lakh+</strong>
                <span>Happy Members</span>
              </div>
              <div className="mg-features-stat-divider"></div>
              <div className="mg-features-stat-item">
                <strong>4.8 ★</strong>
                <span>Average Rating</span>
              </div>
              <div className="mg-features-stat-divider"></div>
              <div className="mg-features-stat-item">
                <strong>₹0</strong>
                <span>To Get Started</span>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="hiw-section">
          <div className="container">
            <div className="hiw-header">
              <span className="hiw-pill">How It Works</span>
              <h2 className="hiw-title">Find Your Perfect Gym in <span className="text-danger">3 Simple Steps</span></h2>
              <p className="hiw-subtitle">No registration fees. No confusion. Just find, compare, and join.</p>
            </div>
            <div className="hiw-steps">
              <div className="hiw-step">
                <div className="hiw-step-num">1</div>
                <div className="hiw-step-icon"><i className="bi bi-search"></i></div>
                <h3 className="hiw-step-title">Search Your City</h3>
                <p className="hiw-step-desc">Enter your city or area in the search bar and instantly browse 5,000+ verified gyms, yoga studios, and fitness centers near you.</p>
              </div>
              <div className="hiw-connector"><i className="bi bi-arrow-right"></i></div>
              <div className="hiw-step">
                <div className="hiw-step-num">2</div>
                <div className="hiw-step-icon"><i className="bi bi-bar-chart-line"></i></div>
                <h3 className="hiw-step-title">Compare & Choose</h3>
                <p className="hiw-step-desc">Read verified member reviews, compare membership plans and prices, check facilities like pool, AC, trainers — then pick the best fit.</p>
              </div>
              <div className="hiw-connector"><i className="bi bi-arrow-right"></i></div>
              <div className="hiw-step">
                <div className="hiw-step-num">3</div>
                <div className="hiw-step-icon"><i className="bi bi-patch-check"></i></div>
                <h3 className="hiw-step-title">Join & Get Fit</h3>
                <p className="hiw-step-desc">Contact the gym directly, book a free trial, and start your fitness journey — completely free, no middlemen, no hidden fees.</p>
              </div>
            </div>
          </div>
        </section>

        {/* App Download Section */}
        <section className="mg-app-section">
          <div className="container">
            <div className="mg-app-inner">
              <div className="mg-app-content">
                <span className="mg-app-pill"><i className="bi bi-phone-fill me-1"></i> Available on Mobile</span>
                <h2 className="mg-app-title">Take MeraGym <span>Everywhere You Go</span></h2>
                <p className="mg-app-desc">Find gyms, track your fitness journey, get membership reminders, and connect with trainers — all from your pocket. Download the MeraGym app free today.</p>
                <ul className="mg-app-perks">
                  <li><i className="bi bi-check-circle-fill"></i> Search gyms in 50+ cities</li>
                  <li><i className="bi bi-check-circle-fill"></i> Get exclusive app-only deals</li>
                  <li><i className="bi bi-check-circle-fill"></i> Track membership & renewals</li>
                  <li><i className="bi bi-check-circle-fill"></i> Connect with certified trainers</li>
                </ul>
                <div className="mg-app-badges">
                  <a href="https://play.google.com/store/apps/details?id=com.techup.mygym" target="_blank" rel="noreferrer" className="mg-app-badge-link">
                    <img src={playstore} alt="Download MeraGym on Google Play Store" />
                  </a>
                  <a href="https://apps.apple.com" target="_blank" rel="noreferrer" className="mg-app-badge-link">
                    <img src={appstore} alt="Download MeraGym on Apple App Store" />
                  </a>
                </div>
              </div>
              <div className="mg-app-visual">
                <div className="mg-app-phone-wrap">
                  <img src={appScreenshot} alt="MeraGym App — Find Gyms Near You" className="mg-app-screenshot" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="member_join_section">
          <div className="container">
            <div className="join">
              <div className="row align-items-center gy-3">
                <div className="col-12 col-lg-6">
                  <img src={member} className="img-fluid" alt="membership" />
                </div>
                <div className="col-12 col-lg-6">
                  <div className="content">
                    <h4 className="title">
                      Get Our Membership and Start Your Fitness Journey Today
                    </h4>
                    <p className="desc">
                      Mera Gym is more than just a fitness center – it's a
                      community of individuals dedicated to transforming their
                      lives through health and wellness.
                    </p>
                    <Link to="/gym-membership-discounts-coupon" className="btn">
                      Get Membership
                      <i className="bi bi-caret-right-fill"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="container px-0">
          <h6 className="offHead text-start avail-text head-row">
            Available In
          </h6>
          <ul className="cities-list">
            {city.map((data) => {
              return (
                <li className="list-items" key={data.city}>
                  <Link to={`/${data.city}/gym`}>{data.city}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <Faq page="home" />

      {/* Sticky mobile CTA — visible only on small screens when user scrolls past hero */}
      <div className="mg-sticky-mobile-cta d-lg-none">
        <Link to="/varanasi/gym" className="mg-sticky-find-btn">
          <i className="bi bi-search me-2"></i>Find Gyms Near Me
        </Link>
      </div>
    </>
  );
}
